<template>
  <div>
    <TopAppBarDrawer></TopAppBarDrawer>
    <div class="main-wrapper flex-grow-1">
      <TopAppBar
        :leftBtnMode="'arrow_back'"
        :title="$t('3590')"
        :leftBtnMethod="handleClose"
        staticMode="true"
      />

      <div class="d-flex align-items-center bg-white fix-header-title">
        <div
          class="t-headline13 t-color-headlineBlack pda-14 t-center flex-grow-1"
        >
          <div class="font-m">{{ this.$t("3590") }}</div>
        </div>
      </div>
      <div class="divider"></div>

      <div class="pda-16 container container--narrow">
        <div class="t-headline9">
          {{ $t("3626") }}
        </div>
        <div class="t-body3 mgt-6 t-color-bodyGrayA">
          {{ $t("3627") }}
        </div>

        <!-- 탈퇴사유 선택 -->
        <div class="mgt-24">
          <div
            v-for="(item, i) in withdrawalList"
            :key="i"
            class="pda-16 pdt-14 pdb-14 mgb-8 b-radius4"
            :class="item.value === selected ? 'bg-quizBlack' : 'bg-quizGray'"
          >
            <div class="mdc-form-field" v-if="item.value !== 'OTHERS'">
              <div class="mdc-radio radio-white">
                <input
                  class="mdc-radio__native-control"
                  type="radio"
                  :value="item.value === selected"
                  :id="`radio_${item.value}`"
                  @click="setSelected(item.value)"
                  @keypress="setSelected(item.value)"
                  tabindex="0"
                  name="reason"
                />
                <div class="mdc-radio__background">
                  <div class="mdc-radio__outer-circle"></div>
                  <div class="mdc-radio__inner-circle"></div>
                </div>
              </div>
              <label
                :for="`radio_${item.value}`"
                class="t-body1"
                :class="
                  item.value === selected
                    ? 't-color-whiteHigh2'
                    : 't-color-quizBlack'
                "
              >
                {{ handleLangWithdrawList(item.value) }}
              </label>
            </div>

            <!-- 기타 사유 -->
            <div
              v-else
              class="w-full mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon pda-0 align-items-center"
            >
              <div class="mdc-radio radio-white">
                <input
                  class="mdc-radio__native-control"
                  type="radio"
                  :value="selected === 'OTHERS'"
                  :id="`radio_${4}`"
                  @click="setSelected(item.value, 'ETC')"
                  @keypress="setSelected(item.value, 'ETC')"
                  tabindex="0"
                  name="reason"
                  maxlength="100"
                />
                <div class="mdc-radio__background">
                  <div class="mdc-radio__outer-circle"></div>
                  <div class="mdc-radio__inner-circle"></div>
                </div>
              </div>
              <div
                class="w-full d-flex flex-column mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon"
                :class="commentValidation ? '' : 'mdc-text-field--invalid'"
                id="reason-input"
              >
                <i class="material-icons mdc-text-field__icon">
                  {{ validIcon }}
                </i>
                <input
                  type="text"
                  class="mdc-text-field__input pdt-5 input-color"
                  maxlength="100"
                  autocomplete="off"
                  v-model="comment"
                  :disabled="!selectedEtc"
                />

                <div class="mdc-notched-outline">
                  <div
                    class="mdc-notched-outline__leading"
                    :class="{ 'selected-outline': selected === 'OTHERS' }"
                  ></div>
                  <div
                    class="mdc-notched-outline__notch"
                    :class="{ 'selected-outline': selected === 'OTHERS' }"
                  >
                    <label
                      for="tf-outlined"
                      class="mdc-floating-label mgt--5"
                      :class="
                        selected === 'OTHERS'
                          ? 't-color-whiteHigh2'
                          : selected === 'OTHERS' && !commentValidation
                          ? 't-color-secondaryBtnText'
                          : ''
                      "
                    >
                      {{ $t("3632") }}
                    </label>
                  </div>
                  <div
                    class="mdc-notched-outline__trailing"
                    :class="{ 'selected-outline': selected === 'OTHERS' }"
                  ></div>
                </div>
                <div
                  class="pdl-10 mgt-1 t-helper text-helper t-color-textfieldActive"
                >
                  <!-- <span> {{ $t("3633") }} </span> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="mgt-50">
          <button
            class="mdc-button mdc-button--raised btn-red mr8 bg-mainBtn"
            @click="next"
            @keypress="next"
          >
            {{ $t("3640") }}
          </button>
          <button
            class="mdc-button btn-white t-color-secondaryBtnText"
            @click="handleClose()"
            @keypress="handleClose()"
            type="button"
            tabindex="0"
          >
            {{ $t("3641") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import memberApi from "@/api/memberApi";
import brandApi from "@/api/brandApi";

export default {
  name: "WithdrawReason",

  components: {
    TopAppBar: () => import("@/components/TopAppBar.vue"),
  },

  data() {
    return {
      withdrawalList: null,
      selected: null,
      selectedEtc: false,
      validIcon: "",
      comment: "",
      commentTextField: "",
      commentValidation: true,
    };
  },

  mounted() {
    this.getWithdrawList();
  },

  updated() {
    this.setMaterialUi();
  },

  watch: {
    selectedEtc: function (val) {
      const el = document.querySelector(".mdc-text-field--disabled");
      if (el && val) {
        el.classList.remove("mdc-text-field--disabled");
      }

      const inputNotchEl = document.querySelector(
        ".mdc-notched-outline--notched"
      );
      if (inputNotchEl && !val) {
        inputNotchEl.classList.remove("mdc-notched-outline--notched");
      }
    },
  },

  methods: {
    setMaterialUi() {
      const reasonInput = document.querySelector("#reason-input");
      const mdcButtonClass = document.querySelectorAll(".mdc-button");
      if (reasonInput) {
        this.commentTextField = new MDCTextField(reasonInput);
        this.commentTextField.useNativeValidation = false;
        const buttonRipple = [].map.call(mdcButtonClass, function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        });
      }
    },

    handleClose() {
      this.$router.replace({
        name: "MyInformation",
      });
    },

    // 탈퇴 사유 리스트 다국어 처리
    handleLangWithdrawList(value) {
      switch (value) {
        case "USELESS":
          return this.$t("3628");

        case "UNSATISFIED_WITH_SERVICE":
          return this.$t("3629");

        case "UNSATISFIED_WITH_CS":
          return this.$t("3630");

        case "PRIVATE_INFO":
          return this.$t("3631");

        default:
          break;
      }
    },

    // GET : 탈퇴 사유 리스트
    async getWithdrawList() {
      try {
        const withDrawListResult = await memberApi.getWithdrawList();
        if (withDrawListResult) {
          const responseList = withDrawListResult.data.data;
          const filteredResponseList = responseList.filter((listItem) => {
            if (listItem.value && listItem.customValues.scope !== "ADMIN") {
              return listItem;
            }
          });
          this.withdrawalList = filteredResponseList;
        }
      } catch (error) {
        console.log("GET LIST ERR : ", error);
      }
    },

    //답안 설정(set answer)
    setSelected(value, type) {
      if (type === "ETC") {
        this.selectedEtc = true;
      } else {
        this.selectedEtc = false;
        this.comment = "";
      }
      this.selected = value;
    },

    // 탈퇴 처리
    async next() {
      if (this.selected === null) {
        return this.$snackOpen({
          contents: this.$t("3636"),
        });
      }

      if (this.selected === "OTHERS" && this.comment.length === 0) {
        this.commentValidation = false;
        return this.$snackOpen({
          contents: this.$t("3876"),
        });
      }

      const params = {
        reason: {},
      };
      if (this.selected === "OTHERS" && this.comment.length > 0) {
        params.comment = this.comment;
      }
      const selected = this.withdrawalList.find(
        (listItem) => listItem.value === this.selected
      );
      params.reason = selected;

      try {
        // 브랜드 설정 정보 즉시 탈퇴 옵션 및 id 확인
        const brandPropertiesResult = await brandApi.getBrandProperties();
        const isWithdrawalActive =
          brandPropertiesResult.data.data.WITHDRAWAL_ACTIVE;
        const memberInfoResult = await memberApi.getMemberInfo();
        const userId = memberInfoResult.data.data.id;

        // 탈퇴 요청 api 요청 -> 다이얼로그 -> 로그인화면
        if (brandPropertiesResult && isWithdrawalActive === "TRUE") {
          const withdrawDirectResult = await memberApi.withdrawAccountDirect(
            userId,
            params
          );
          if (withdrawDirectResult && withdrawDirectResult.data.data) {
            this.$alert({
              content: this.$t("3650"),
              accept: this.$t("3651"),
            }).then(() => {
              this.$router.replace({
                name: "Login",
              });
            });
          }
        }

        // 탈퇴 요청 request api 요청 -> 다이얼로그 -> 마이인포메이션화면
        console.log(isWithdrawalActive);
        if (brandPropertiesResult && isWithdrawalActive === "FALSE") {
          const withdrawRequestResult = await memberApi.withdrawAccountRequest(
            params
          );
          if (withdrawRequestResult && withdrawRequestResult.data.data) {
            this.$alert({
              title: this.$t("3509"),
              content: this.$t("3510"),
              accept: this.$t("3511"),
            }).then(() => {
              this.$router.replace({
                name: "MyInformation",
              });
            });
          }
        }
      } catch (error) {
        console.log("Withdraw error : ", error);
      }
    },
  },
};
</script>
  
  
  <style scoped>
.warning {
  color: #fc5356 !important;
}

.selected-outline {
  border-color: var(--WhiteHigh2) !important;
}

.input-color {
  caret-color: var(--WhiteHigh2) !important;
  color: var(--WhiteHigh2) !important;
}

.mdc-text-field .mdc-text-field__input {
  caret-color: var(--WhiteHigh2) !important;
}
</style>